export default "__VITE_ASSET__D3QgQWZ3__"